import apiClient from "../../utils/apiClient";

const API_URL = "/admin/applications";

export async function getAllApplications() {
    try {
        const response = await apiClient.get(`${API_URL}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching applications:", error);
        throw error;
    }
}

export async function getApplicationById(applicationId) {
    try {
        const response = await apiClient.get(`${API_URL}/${applicationId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching application details:", error);
        throw error;
    }
}

export async function updateApplicationStatus(applicationId, statusData) {
    try {
        const response = await apiClient.put(`${API_URL}/${applicationId}/status`, statusData);
        return response.data;
    } catch (error) {
        console.error("Error updating application status:", error);
        throw error;
    }
}

export async function requestReupload(applicationId, dataId, requested) {
    try {
        const response = await apiClient.put(`${API_URL}/${applicationId}/reupload/${dataId}`, { requested });
        return response.data;
    } catch (error) {
        console.error("Error requesting reupload:", error);
        throw error;
    }
}